/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import React, { styled } from 'fierry/react.old';


const getColor = (props) =>
{
  if (props.primaryColor)
  {
    return 'var(--svg-always-black)';
  }

  if (props.secondaryColor)
  {
    return 'var(--svg-always-other)';
  }

  return null;
}


const getOpacity = ({ opacityValue }) =>
{
  return opacityValue || 0;
}


const Background = styled.polygon`
  fill: ${props => getColor(props)};
  fill-opacity: ${props => getOpacity(props)};
`;


const getPolygonPoints = ({ geometry, location }) =>
{
  const callback = ({ x, y }) => `${x},${y}`;

  return geometry.getZone(location).getCurrentPoints().map(callback).join(' ');
}


export default (props) =>
(
  <Background {...props} points = {getPolygonPoints(props)} />
);
